/* global $ window */

import cookie from 'js-cookie'
import AbPubSub from '$lib/ab_pubsub'
import Events from '../../../javascript/src/config/events'
import { hideNavBackdrop } from '$lib/navigation_backdrop_helper'

const USER_MAIL_INPUT_SELECTOR = '.js-modal__email'
const USER_MAIL_ICON_SELECTOR = '.login-at'
const PASSWORD_FIELD_INPUT = '.js-modal__password'
const LOCK_ICON_SELECTOR = '.login-lock'

export default class ModalLoginWidget {
  get signInRoute() {
    return '/account/signin/'
  }

  get submitBtnSelector() {
    return '.js-modal__submit--login'
  }

  get registerModalSelector() {
    return '.js-modal-register'
  }

  get modalSelector() {
    return '.js-modal-login'
  }

  get loginLinkSelector() {
    return '.js-open_login_modal'
  }

  constructor() {
    const $apprenticeLoginLink = $(this.loginLinkSelector)
    const $modal = $(this.modalSelector)
    const $registerModal = $(this.registerModalSelector)
    const $submitButton = $(this.submitBtnSelector)
    this.$apprenticeLoginLink = $apprenticeLoginLink[0]
    this.$userLoginIcon = $(USER_MAIL_ICON_SELECTOR)
    this.$userMailInput = $(USER_MAIL_INPUT_SELECTOR)
    this.$passwordFieldInput = $(PASSWORD_FIELD_INPUT)
    this.$lockIcon = $(LOCK_ICON_SELECTOR)
    this.$modal = $modal
    this.$registerModal = $registerModal
    this.$namespace = $('.modal__content')
    let popUp = ''

    const abPubSub = AbPubSub.getInstance()

    abPubSub.subscribe(Events.ON_OPEN_LOGIN_MODAL, () => {
      $registerModal.hide()
      $modal.css('display', 'flex')
    })

    abPubSub.subscribe(Events.ON_RELOAD_LOGIN_LINKS, () => {
      $(this.loginLinkSelector).on('click', e => {
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()

        const $clicked = $(e.currentTarget).data('triggerPopup')

        // used for triggering content after login like follow card, author-form-box
        if ($clicked) {
          popUp = $clicked
        } else {
          popUp = ''
        }

        $registerModal.hide()
        $modal.css('display', 'flex')
      })

    })

    $apprenticeLoginLink.on('click', e => {
      e.preventDefault()
      e.stopPropagation()

      const $clicked = $(e.currentTarget).data('triggerPopup')

      // used for triggering content after login like follow card, author-form-box
      if ($clicked) {
        popUp = $clicked
      } else {
        popUp = ''
      }

      $registerModal.hide()
      $modal.css('display', 'flex')
    })

    $modal.find('.js-login-modal-cross').on('click', e => {
      e.preventDefault()
      hideNavBackdrop()
      $modal.hide()
    })

    $submitButton.on('click', e => {
      e.preventDefault()
      this.clearErrors()

      $.ajax({
        url: `/ajax${this.signInRoute}`,
        method: 'POST',
        data: this.getSerializedFormData()
      })
        .done(xhr => {
          if (popUp) {
            cookie.set('triggerPopUp', popUp, { expires: 1 })
          }
          // dont use cached document
          window.location = xhr.redirect
        })
        .fail(jqXHR => {
          // response is an object, so create an array from key-value pairs
          this.addFieldError(jqXHR.responseJSON.errors)
        })
    })
    this.onUserMailInputListener()
    this.onPasswordFieldInputListener()
    this.automaticallyOpenLoginModal()
  }

  addFieldError(errors) {
    $.each(errors, (key, value) => {
      const $inputField = this.$namespace.find('form').find(`.modal__${key}`)

      if (key !== 'general') {
        $inputField.on('keypress', this.removeError)
      }

      let parentElement = $inputField.parent()
      if (key === 'password') {
        parentElement = parentElement.parent()
      }

      parentElement.addClass('field_with_errors')
      this.addErrorMessage(parentElement, value)
    })
  }

  removeError() {
    const $input = $(this)
    $input.off('keypress')
    let parentElement = $input.parent()

    if ($input.hasClass('modal__password')) {
      parentElement = parentElement.parent()
    }

    parentElement.removeClass('field_with_errors').find('span').remove()
  }

  addErrorMessage(element, messages) {
    messages.forEach(message => {
      element.append(`<div class="form-error-message">${message}</div>`)
    })
  }

  clearErrors() {
    const errorInputElements = this.$namespace.find('form').find('.field_with_errors')
    errorInputElements.removeClass('field_with_errors').find('.form-error-message').remove()
  }

  getSerializedFormData() {
    return this.$namespace.find('form').serialize()
  }

  onUserMailInputListener() {
    this.$userMailInput.on('input', () => {
      this.$userLoginIcon.toggleClass('filled', this.$userMailInput[0].value.length > 0)
    })
  }

  onPasswordFieldInputListener() {
    this.$passwordFieldInput.on('input', () => {
      // Since 'this.$passwordFieldInput[0].value.length' always returns
      // 0 it is not possible to toggle the color when the input is deleted
      this.$lockIcon[0].classList.add('filled')
    })
  }

  automaticallyOpenLoginModal() {
    if (!!this.$namespace[0] && this.$namespace[0].dataset.jsOpenLoginModal === '1') {
      this.$apprenticeLoginLink.click()
    }
  }
}
